/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
export const pwaIframeEvent = `
const iframe = iframeRef.current;
if (event.data.type === 'flora-conv-ui-session-info') {
   if (brand?.code === 'CSG' || brand?.version === '5.0') {
      const url = window?.location?.href || '';
      const browseruuid = localStorage?.getItem('browserUUID') || '';
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      iframe.contentWindow.postMessage({
            type: 'flora-session-storage-data', 
            data: { url, brand, browser, deviceType, operatingSystem, brandTheme, auth: { isAuthenticated: !!userInfo?.profile?.email }, profile: userInfo?.profile, enterprise: {enterpriseId: ''}, browseruuid, token: userInfo?.token || token || '' }
      }, '*');
   } else {
      const url = window?.location?.href || '';
      const auth = JSON.parse(JSON.parse(sessionStorage.getItem('persist:member') || '{}')?.auth || '{}');
      const profile = JSON.parse(JSON.parse(sessionStorage.getItem('persist:member') || '{}')?.profile || '{}');
      const enterprise = JSON.parse(JSON.parse(sessionStorage.getItem('persist:member') || '{}')?.enterpriseId || '{}');
      const browseruuid = localStorage?.getItem('browserUUID') || '';
      iframe.contentWindow.postMessage({
         type: 'flora-session-storage-data',
         data: { url, brand, browser, deviceType, operatingSystem, brandTheme, auth, profile, enterprise, browseruuid, token, }
      }, '*');
   }
}

if (event.data.type === 'flora-search-suggestion-submitted' && iframe?.contentWindow) {
   iframe.contentWindow.postMessage(
       { type: 'flora-update-chat-message-search', data: event.data },
       '*');
}
if (event.data.type === 'flora-footer-suggestion-submitted' && iframe?.contentWindow) {
   iframe.contentWindow.postMessage(
       { type: 'flora-update-chat-message-footer', data: event.data },
       '*');
}
if (event.data.type === 'flora-get-access-token' && iframe?.contentWindow) {
   if (brand?.code === 'CSG' || brand?.version === '5.0') {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
      iframe.contentWindow.postMessage(
         { type: 'flora-update-access-token', data: userInfo?.token || token || '' },
            '*');
   } else {
      iframe.contentWindow.postMessage(
         { type: 'flora-update-access-token', data: token },
            '*');
   }
}
if (event.data.type === 'flora-get-page-info' && iframe?.contentWindow) {
   setIsFloraChatBtnClicked(true)
   iframe.contentWindow.postMessage(
       { type: 'flora-update-page-info', data: pageTypeRef.current },
       '*');
}
if (event.data.type === 'flora-navigateProductPage') {
   window.location.href = event.data.url;
}
if (event.data.type === 'flora-chat-iframe-maximised') {
   if (isMobile) {
       setIsIframeMaximized(true);
       iframeRef.current.style.top = '0';
       iframeRef.current.style.height = '100dvh';
       iframeRef.current.style.width = '100vw';
       iframeRef.current.style.right = '';
       iframeRef.current.style.bottom = '';
   } else {
      const screenWidth = window.innerWidth;
    if(screenWidth < 1024) {
      iframeRef.current.style.width = '45%';
      iframeRef.current.style.height = '75%';
      iframeRef.current.style.bottom = '-7%';
      iframeRef.current.style.right = '0%';
    } else if (screenWidth >= 1024 && screenWidth <= 1280) {
      iframeRef.current.style.width = '40%';
      iframeRef.current.style.height = '75%';
      iframeRef.current.style.bottom = '-6%';
      iframeRef.current.style.right = '0%';
    } else if (screenWidth > 1280 && screenWidth <= 1440) {
      iframeRef.current.style.width = '32%';
      iframeRef.current.style.height = '75%';
      iframeRef.current.style.bottom = '-4%';
      iframeRef.current.style.right = '0%';
    } else if (screenWidth > 1440 && screenWidth <= 1920) {
      iframeRef.current.style.width = '30%';
      iframeRef.current.style.height = '75%';
      iframeRef.current.style.bottom = '-4%';
      iframeRef.current.style.right = '2%';
    } else if (screenWidth > 1920) {
      iframeRef.current.style.width = '20%';
      iframeRef.current.style.height = '75%';
      iframeRef.current.style.bottom = '-5%';
      iframeRef.current.style.right = '1%';
    }
}
}
if (event.data.type === 'flora-chat-iframe-minimised') {
   setIsIframeMaximized(false);
   iframeRef.current.style.width = '120px';
   iframeRef.current.style.height = '80px';
   iframeRef.current.style.top = '';
   iframeRef.current.style.bottom = '10px';
   iframeRef.current.style.right = '0%';
}
if (event.data.type === 'flora-chat-preview-msg-closed') {
   iframeRef.current.style.width = '120px';
   iframeRef.current.style.height = '80px';
   iframeRef.current.style.right = '0%';
}
if (event.data.type === 'flora-preview-msg-ready') {
   iframeRef.current.style.width = '350px';
   iframeRef.current.style.height = '150px';
};
if (event.data.type === 'flora-no-preview-msg') {
   iframeRef.current.style.width = '120px';
   iframeRef.current.style.height = '80px';
}
`;
